import { lazy, Suspense } from "react";
import HeroSection from "./HeroSection";
import { Helmet } from "react-helmet";

const ConsultantSection = lazy(() => import("./ConsultantSection"));
const BenefitsSection = lazy(() => import("./BenefitsSection"));
const Features = lazy(() => import("./Features"));

const SoftwareConsulting = () => {
  return (
    <>
      <Helmet>
        <title>
          Expert Software Consulting Services | Accelerate Digital
          Transformation
        </title>
        <meta
          name="description"
          content="Boost your business growth with expert software consulting. Our senior consultants provide strategic guidance, optimized systems, and flexible solutions for smarter decision-making and accelerated digital transformation."
        />
        <meta
          name="keywords"
          content="IT strategy consulting, technology consulting, business technology solutions, software project management, software optimization, IT consulting experts, strategic software solutions
      "
        />
      </Helmet>
      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <ConsultantSection />
        <section className="w-full font-poppins">
          <BenefitsSection />
          <Features />
        </section>
      </Suspense>
    </>
  );
};

export default SoftwareConsulting;
